import moment from 'moment';
import { IsComeOn, IsLeo, IsPaf, IsVideo, GetFlexNumber, productNamesC, themeC } from "../theme/themehelper";
import { DateTime } from 'luxon';
import { isTheGameRoundName } from '../roundview/components/thegame/thegamemanifest';


export const getReducedFiendlyName = (name) => {
  let friendlyName = name.replaceAll('_', '-');
  return friendlyName;
}

export const formatFraction = v => `${(parseFloat(v) * 100).toFixed(0)}%`;


export const getRoundName = (round, t) => {

  if (!round) {
    return "";
  }

  if (isTheGameRoundName(round.name)) {
    return t('the_game');
  }

  var isKung = IsVideo(window.theme);
  // The themes that label Max/Mix/Flex rounds with the Orange product name; Green, Kryss and Hard brand them separately below.
  var isLeo = IsLeo(window.theme) && !IsComeOn(window.theme) && !IsPaf(window.theme)
    && window.theme !== themeC.Hard && window.theme !== themeC.Green;
  var isComeOnOther = IsComeOn(window.theme);
  var isHard = window.theme === themeC.Hard;

  switch (round.name) {
    case 'Maxtipset':
    case 'MaxtipsetEUR':
      if (isKung) {
        return "Super 13";
      }
      if (isLeo) {
        return productNamesC.Orange.Max + " 13";
      }
      if (window.theme === themeC.ComeOn || window.theme === themeC.Snabbare || window.theme === themeC.Hajper
        || window.theme === themeC.Stugan || window.theme === themeC.Reviant
      ) {
        return "13 Matcher";
      }
      if (isComeOnOther) {
        return productNamesC.ComeOn.Max + " 13";
      }
      if (isHard) {
        return productNamesC.Hard.Max + " 13";
      }
      if (window.theme === themeC.Green) {
        return "13 Rätt";
      }
      return t('max') + ' 13';
    case 'Mixtipset':
    case 'MixtipsetEUR':
      if (isKung) {
        return "Super 12";
      }
      if (isLeo) {
        return productNamesC.Orange.Mix + " 12";
      }
      if (window.theme === themeC.ComeOn || window.theme === themeC.Snabbare || window.theme === themeC.Hajper
        || window.theme === themeC.Stugan || window.theme === themeC.Reviant) {
        return "12 Matcher";
      }
      if (isComeOnOther) {
        return productNamesC.ComeOn.Mix + " 12";
      }
      if (isHard) {
        return productNamesC.Hard.Mix + " 12";
      }
      if (window.theme === themeC.Green) {
        return "12 Rätt";
      }
      return t('mix') + ' 12';
    case 'Flextipset6':
    case 'Flextipset8':
    case 'Flextipset10':
    case 'Flextipset6EUR':
    case 'Flextipset8EUR':
    case 'Flextipset10EUR':
      if (isKung) {
        switch (round.name) {
          case 'Flextipset6':
          case 'Flextipset6EUR':
            return "Super 6";
          case 'Flextipset8':
          case 'Flextipset8EUR':
            return "Super 8";
          case 'Flextipset10':
          case 'Flextipset10EUR':
            return "Super 10";
          default:
            return "Super";
        }
      }
      if (isLeo) {
        return productNamesC.Orange.Flex + " " + GetFlexNumber(round.name);
      }
      if (window.theme === themeC.ComeOn || window.theme === themeC.Snabbare || window.theme === themeC.Hajper
        || window.theme === themeC.Stugan || window.theme === themeC.Reviant) {
        return "8 Matcher";
      }
      if (isComeOnOther) {
        return productNamesC.ComeOn.Flex + " 8";
      }
      if (isHard) {
        return productNamesC.Hard.Flex + " 8";
      }
      if (window.theme === themeC.Green) {
        return "8 Rätt";
      }
      return t('flex') + ' 8';
    case 'Survivor8':
      if (window.theme === themeC.Green) {
        return 'Stegen 8';
      }
      return t('survivor8') + ' 8';
    case 'Survivor6':
      if (window.theme === themeC.Green) {
        return 'Stegen 6';
      }
      return t('survivor8') + ' 6';
    default:
      if (window.theme === themeC.Green && round.name && round.name.indexOf("Hockey") > -1) {
        return "Hockey " + GetFlexNumber(round.name);
      }
      return round.name;
  }

}

export const getBackground = (round) => {

  if (!round) {
    return '#B8CCF1';
  }

  switch (round.name) {
    case 'Maxtipset':
    case 'MaxtipsetEUR':
      return '#B8CCF1';
    case 'Mixtipset':
    case 'MixtipsetEUR':
      return '#FAEEAE';
    case 'Flextipset6':
    case 'Flextipset8':
    case 'Flextipset10':
    case 'Flextipset6EUR':
    case 'Flextipset8EUR':
    case 'Flextipset10EUR':
      return '#E0D8EE';
    default:
      return '#B8CCF1';
  }

}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getRoundStatus(round, startDate, t) {
  let roundStatus = t('round_status_open')

  const isAfterDeadline = startDate < Date.now();

  if (round.status === "FINISHED") {
    roundStatus = t('round_status_finished');
  } else if (round.status === "ACTIVE") {
    roundStatus = t('round_status_open');
    if (isAfterDeadline) {
      roundStatus = t('round_active_after_deadline');
    }
  } else if (round.status === "VOIDED") {
    roundStatus = t('round_status_voided');
  } else if (round.status === "PAUSED") {
    roundStatus = t('round_status_paused');
  } else {
    roundStatus = "N/A";
  }

  return roundStatus;
}


export function isCurrencyWithWholeNumbers(currency) {
  switch (currency) {
    case 'TZS':
    case 'IRR':
    case 'IRT':
      return true;
    default:
      break;
  }
  return false;
}

export const getDateStringForClosed = (round, t) => {

  if (!round) {
    return "";
  }  

  let locale = t('locale');

  let dateTime = DateTime.fromJSDate(new Date(round.openTo)).setLocale(locale);
  let formattedTime = dateTime.toFormat('yyyy-MM-dd HH:mm');

  return formattedTime;

}

export const getDateString = (round, t) => {

  if (!round) {
    return "";
  }

  const start = new Date(round.openTo);
  const now = new Date(Date.now());
  let today = now;
  today.setHours(0, 0, 0, 0);
  let startDate = start;
  startDate.setHours(0, 0, 0, 0);

  let locale = t('locale');

  let dateTime = DateTime.fromJSDate(new Date(round.openTo)).setLocale(locale);
  let formattedTime = dateTime.toFormat('cccc HH:mm')

  if (startDate < today) {
    return moment(round.openTo).locale(locale).format("L");
  }
  else if (startDate.toDateString() !== today.toDateString()) {
    if (locale === "am-ET")
      return formattedTime;
    return capitalizeFirstLetter(moment(round.openTo).locale(locale).format("dddd HH:mm"));
  }
  else {
    let dateStr = t('today');
    dateStr += ' ';
    dateStr += moment(round.openTo).locale(locale).format("HH:mm");
    return dateStr;
  }
}

export function getProPickSuggestions(round) {
  switch (round.name) {
    case "Maxtipset":
    case "MaxtipsetEUR":
      return [
        { rows: 64, dif: 'Easy', numFull: 0, numHalf: 6 },
        { rows: 144, dif: 'Easy', numFull: 2, numHalf: 4 },
        { rows: 216, dif: 'Easy', numFull: 3, numHalf: 3 },
      ];
    case "Mixtipset":
    case "MixtipsetEUR":
      return [
        { rows: 64, dif: 'Easy', numFull: 0, numHalf: 6 },
        { rows: 144, dif: 'Easy', numFull: 2, numHalf: 4 },
        { rows: 216, dif: 'Easy', numFull: 3, numHalf: 3 },
      ];
    default:
      return [
        { rows: 64, dif: 'Easy', numFull: 0, numHalf: 6 },
        { rows: 144, dif: 'Easy', numFull: 2, numHalf: 4 },
      ];
  }
}